<template>
    <b-row :id="item.id" :key="item.id">
        <!-- Form Group for Inputs -->
        <b-col :md="mdSize">
            <b-form-group :label="label" :label-for="inputId">
                <b-form-input v-if="type === 'input'" :id="inputId" v-model="modelValue" :type="inputType"
                    :placeholder="placeholder" />
                <b-form-textarea v-else :id="inputId" v-model="modelValue" :placeholder="placeholder" />
            </b-form-group>
        </b-col>

        <!-- Remove Button -->
        <b-col lg="3" md="4" class="mb-50">
            <b-button :id="`delete-${item.id}`" v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger"
                class="mt-0 mt-md-2" @click="$emit('remove', index)">
                <feather-icon icon="XIcon" class="mr-25" />
                <span>Delete</span>
            </b-button>
        </b-col>

        <!-- Divider -->
        <b-col cols="12">
            <hr />
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        item: Object,
        index: Number,
        label: String,
        inputId: String,
        modelValue: [String, Number],
        placeholder: String,
        inputType: {
            type: String,
            default: 'text',
        },
        mdSize: {
            type: Number,
            default: 5,
        },
        type: {
            type: String,
            default: 'input', // 'input' or 'textarea'
        },
    },
    emits: ['remove'],
};
</script>
